import introductionText      from './introduction.md';
import siteTypesText         from './siteTypes.md';
import designTypesText       from './designTypes.md';
import buildSpeedText        from './buildSpeed.md';
import amountOfPagesText     from './amountOfPages.md';
import featuresText          from './features.md';
import eCommerceFeaturesText from './eCommerceFeatures.md';
import customProductionText  from './customProductionFeatures.md';
import externalCostsText     from './externalCosts.md';
import ratesText             from './rates.md';
import WordPressText         from './whyWordPress.md';
export default{
	introductionText,
	siteTypesText,
	designTypesText,
	buildSpeedText,
	amountOfPagesText,
	featuresText,
	eCommerceFeaturesText,
	customProductionText,
	externalCostsText,
	ratesText,
	WordPressText
};


// WEBPACK FOOTER //
// ./src/static/content/index.js